import { IExpertView } from '../../types/expertView';

export function expertViewReducer(state: IExpertView | null = null) {
  return state;
}
